// extracted by mini-css-extract-plugin
export default {"separator":"kqJNFdePp4AT0WIfAU6q","vertical":"gGtlsYtx28xKHx3m_Rv0"};